import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Bell + dropdown in the shared top-bar menu idiom (TopBar/SiteSwitcher).
export const styles = {
  wrap: {
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  iconBtn: {
    kVAEAm: "x1n2onr6",
    kzqmXN: "x14qfxbe",
    kZKoxP: "xc9qbxq",
    k1xSpc: "xrvj5dj",
    kgQiWS: "x1ku5rj1",
    kaIpWk: "xxltkoq",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x9r1u3d",
    kWkggS: "xjbqb8w",
    kMwMTN: "xdxw5r1",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1k3q35m",
    kI3sdo: "x1a2a7pz xx4dj4q",
    kGzVvX: "x5lqt2c",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  badge: {
    kVAEAm: "x10l6tqk",
    k87sOh: "xs7f9wi",
    kCIrl2: "x3lmqil",
    k7Eaqz: "x15kz4h8",
    kZKoxP: "xlup9mm",
    kg3NbH: "xfn1xvj",
    kaIpWk: "xoy5co8",
    kWkggS: "x4qlrbh",
    kMwMTN: "xahmsqx",
    kGuDYH: "x1sfnd48",
    k63SB2: "x1xlr1w8",
    kLWn49: "x1d3mw78",
    k9WMMc: "x2b8uid",
    $$css: true
  },
  menu: {
    kVAEAm: "x10l6tqk xegw5ml",
    k87sOh: "xwwefxd x150vwk6",
    kCIrl2: "x3m8u43 x77kb69",
    kY2c9j: "xf5e64p",
    kzqmXN: "xiuupyq x1lt17tl xxm907u",
    kmVPX3: "xrqf348",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xaj8nyx",
    kaIpWk: "xxltkoq",
    kGVxlE: "xkqgayn",
    $$css: true
  },
  head: {
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "x1qughib",
    k8WAf4: "xyggvxn",
    kg3NbH: "x1l89hgl",
    kt9PQ7: "xso031l",
    kfdmCh: "x1q0q8m5",
    kL6WhQ: "xra1o3",
    k1K539: "x1vvky8i",
    $$css: true
  },
  headTitle: {
    kGuDYH: "x2pyw9z",
    k63SB2: "xomqrzn",
    kMwMTN: "x1oezkus",
    $$css: true
  },
  readAll: {
    ksu8eU: "xng3xce",
    kWkggS: "xjbqb8w",
    kMwMTN: "x1459q0w",
    kMv6JI: "xdv2sak",
    kGuDYH: "x34ze3o",
    k63SB2: "xssbmp7",
    kkrTdU: "x1ypdohk",
    kmVPX3: "x1717udv",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x1hl8ikr",
    k67Jb4: "xt0b8zv",
    $$css: true
  },
  empty: {
    kmVPX3: "xbnq24e",
    k9WMMc: "x2b8uid",
    kGuDYH: "x2pyw9z",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  list: {
    kskxy: "x1a3r9hi x6kwnfu",
    kORKVm: "x1odjw0f",
    $$css: true
  },
  item: {
    k1xSpc: "x78zum5",
    kGNEyG: "x1cy8zhl",
    kOIVth: "x1mnnc3i",
    kzqmXN: "xh8yej3",
    k8WAf4: "xyggvxn",
    kg3NbH: "x1l89hgl",
    kaIpWk: "x1d0dq8e",
    kmkexE: "x1ujv9i6",
    kGzVvX: "x5lqt2c",
    $$css: true
  },
  itemUnread: {
    kWkggS: "x48i0l6",
    $$css: true
  },
  itemTitleUnread: {
    k63SB2: "xomqrzn",
    kMwMTN: "x1oezkus",
    $$css: true
  },
  itemTitleRead: {
    k63SB2: "x1fm9vgf",
    kMwMTN: "xdxw5r1",
    $$css: true
  },
  itemMetaRead: {
    kMwMTN: "x1em627c",
    $$css: true
  },
  dot: {
    kzqmXN: "x1xc55vz",
    kZKoxP: "xdk7pt",
    kaIpWk: "xoy5co8",
    kmuXW: "x2lah0s",
    keoZOQ: "x1ok221b",
    $$css: true
  },
  info: {
    kWkggS: "xdk5f74",
    $$css: true
  },
  warning: {
    kWkggS: "x7dh1j1",
    $$css: true
  },
  critical: {
    kWkggS: "x4qlrbh",
    $$css: true
  },
  itemBody: {
    kUk6DE: "x98rzlu",
    k7Eaqz: "xeuugli",
    kmVPX3: "x1717udv",
    ksu8eU: "xng3xce",
    kWkggS: "xjbqb8w",
    k9WMMc: "xdpxx8g",
    kMv6JI: "xdv2sak",
    kkrTdU: "x1ypdohk xtgyt42",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x1hl8ikr",
    $$css: true
  },
  itemLink: {
    kybGjl: "x1hl2dhg",
    k1xSpc: "x1lliihq",
    $$css: true
  },
  itemTitle: {
    kGuDYH: "x2pyw9z",
    k63SB2: "xssbmp7",
    kMwMTN: "x1oezkus",
    kHjlTd: "xj0a0fe",
    $$css: true
  },
  itemMeta: {
    kGuDYH: "x34ze3o",
    kMwMTN: "xdxw5r1",
    keoZOQ: "xr9ek0c",
    $$css: true
  },
  ackBtn: {
    kmuXW: "x2lah0s",
    kmVPX3: "xdqdrvq",
    kaIpWk: "x1d0dq8e",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1vgqim1",
    kWkggS: "xjbqb8w",
    kMwMTN: "x2wi9gy",
    kMv6JI: "xdv2sak",
    kGuDYH: "x34ze3o",
    k63SB2: "xomqrzn",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1k3q35m",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    kGzVvX: "xur8raz",
    $$css: true
  },
  seeAll: {
    k1xSpc: "x1lliihq",
    k9WMMc: "x2b8uid",
    kmVPX3: "x7z7khe",
    kGuDYH: "x2pyw9z",
    k63SB2: "xomqrzn",
    kMwMTN: "x1459q0w",
    kybGjl: "x1hl2dhg",
    kEafiO: "x178xt8z",
    kPef9Z: "x13fuv20",
    kLZC3w: "x1p7xzfl",
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    kGzVvX: "x5lqt2c",
    $$css: true
  }
};